import { type FC } from 'react';
import {
  ArrowsClockwise
} from '@phosphor-icons/react';
import { UiIcon, type UiIconProps } from './UiIcon';

export type UiIconArrowsClockwiseProps = Omit<UiIconProps, 'IconComponent'>;

export const UiIconArrowsClockwise: FC<UiIconArrowsClockwiseProps> = (props) => {
  return (
    <UiIcon
      IconComponent={ArrowsClockwise}
      {...props}
    />
  );
};
